import { mogamboRequestV2 } from '@src/api/utils';
import { BASE_URL } from '@src/const';

export const fetchConnectionData = (
  sourceType,
  sourceID,
  destinationType,
  destinationID,
  langSrc,
  langScript
) => {
  const url = `${BASE_URL}connection/${sourceType}/${sourceID}/${destinationType}/${destinationID}/?lang_src=${langSrc}&lang_script=${langScript}`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const saveConnectionData = ({
  sourceType,
  sourceID,
  destinationType,
  destinationID,
  data,
  domainTitle=''
}) => {
  const url = `${BASE_URL}connection/${sourceType}/${sourceID}/${destinationType}/${destinationID}/`;
  const headers =  {
    'x-haptik-bot-name': domainTitle,
  };
  return mogamboRequestV2(url, 'POST', data, false, headers);
};
